var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadOrangeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00065 9.33301C2.36884 9.33301 2.66732 9.63148 2.66732 9.99967V12.6663C2.66732 12.8432 2.73756 13.0127 2.86258 13.1377C2.9876 13.2628 3.15717 13.333 3.33398 13.333H12.6673C12.8441 13.333 13.0137 13.2628 13.1387 13.1377C13.2637 13.0127 13.334 12.8432 13.334 12.6663V9.99967C13.334 9.63148 13.6325 9.33301 14.0007 9.33301C14.3688 9.33301 14.6673 9.63148 14.6673 9.99967V12.6663C14.6673 13.1968 14.4566 13.7055 14.0815 14.0806C13.7065 14.4556 13.1978 14.6663 12.6673 14.6663H3.33398C2.80355 14.6663 2.29484 14.4556 1.91977 14.0806C1.5447 13.7055 1.33398 13.1968 1.33398 12.6663V9.99967C1.33398 9.63148 1.63246 9.33301 2.00065 9.33301Z",
    fill: "#FB7B33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.19526 6.19526C4.45561 5.93491 4.87772 5.93491 5.13807 6.19526L8 9.05719L10.8619 6.19526C11.1223 5.93491 11.5444 5.93491 11.8047 6.19526C12.0651 6.45561 12.0651 6.87772 11.8047 7.13807L8.4714 10.4714C8.21106 10.7318 7.78894 10.7318 7.5286 10.4714L4.19526 7.13807C3.93491 6.87772 3.93491 6.45561 4.19526 6.19526Z",
    fill: "#FB7B33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00065 1.33301C8.36884 1.33301 8.66732 1.63148 8.66732 1.99967V9.99967C8.66732 10.3679 8.36884 10.6663 8.00065 10.6663C7.63246 10.6663 7.33398 10.3679 7.33398 9.99967V1.99967C7.33398 1.63148 7.63246 1.33301 8.00065 1.33301Z",
    fill: "#FB7B33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadOrangeIcon);
export default __webpack_public_path__ + "static/media/download-orange-icon.677eae0ae005151f9163faf01dc519aa.svg";
export { ForwardRef as ReactComponent };